module.exports = __webpack_public_path__ + "img/hr-V-L-2-unload-connect-shadow.e602e345.png";